import { mapPersonalInfoType, PersonalInfoType } from "../PersonalInfoType";
import { mapUserRoleInfoType, UserRoleInfoType } from "../UserRoleInfoType";

/* ******************************************************* Attendance payed data */
export interface AttendancePayedData {
    id?: number;
    personal_info_id?: number;
    date?: string;
    payed_amount?: number | null;
    advance_payment?: number | null;
    grand_total?: number | null;
}

export const mapAttendancePayedData = (data: any): AttendancePayedData => {
    if (!data) {
        throw new Error('Invalid Data')
    }

    const response: AttendancePayedData = {
        id: data.id,
        personal_info_id: data.personal_info_id,
        date: data.date,
        payed_amount: data.payed_amount ?? null,
        advance_payment: data.advance_payment ?? null,
        grand_total: data.grand_total ?? null
    }

    return response;
}

export const mapAttendancePayedDatas = (data: any[]): AttendancePayedData[] => {
    if (!Array.isArray(data)) {
        throw new Error('Invalid Data');
    }

    return data.map(mapAttendancePayedData);
}
/* ******************************************************* */


/* ******************************************************* Attendance data */
export interface AttendanceData {
    personal_info_id?: number;
    attendance_date?: string;
    work_hours?: number;
    work_days?: number;
    this_day_wage?: number | null;
    payed_data?: AttendancePayedData | null;
    personalInfo?: PersonalInfoType | null;
    userRoleInfo?: UserRoleInfoType | null;
}

export const mapAttendanceData = (data: any): AttendanceData => {
    if (!data) {
        throw new Error('Invalid Data')
    }

    const response: AttendanceData = {
        personal_info_id: data.personal_info_id,
        attendance_date: data.attendance_date,
        work_hours: data.work_hours,
        work_days: data.work_days,
        this_day_wage: data.this_day_wage ?? null,
        payed_data: (data.payed_data !== null) ? mapAttendancePayedData(data.payed_data) : null,
        personalInfo: (data.personalInfo !== null) ? mapPersonalInfoType(data.personalInfo) : null,
        userRoleInfo: (data.userRoleInfo !== null) ? mapUserRoleInfoType(data.userRoleInfo) : null,
    }

    return response;
}

export const mapAttendanceDatas = (data: any[]): AttendanceData[] => {
    if (!Array.isArray(data)) {
        throw new Error('Invalid Data');
    }

    return data.map(mapAttendanceData);
}
/* ******************************************************* */